import React, {useState, useEffect, useCallback, useContext} from 'react';
import {OverlayContext} from './../../contexts/OverlayContext';
import styled from 'styled-components';

import {OzContainer, OzRow, OzCol, OzCard, OzTable, OzUserTag} from '@ozwol/webui';

import CustomizationfeesService from '../../services/CustomizationfeesService';
import UsersService from './../../services/UsersService';

import InsiderCustomizationfeesModalNew from './InsiderCustomizationfeesModalNew';

import Filters from '../../components/Filters';
import Meta from '../../components/Meta';
import ModalError from '../../components/ModalError';
import PageHeader from '../../components/PageHeader';
import NoResult from '../../components/NoResult';
import CardHeaderTitle from '../../components/CardHeaderTitle';
import HealthyWrapper from '../../components/HealthyWrapper';
import PromptedButton from '../../components/PromptedButton';

import {formatError} from './../../helpers';
import {OVERLAY_TIMEOUT_ERROR} from '../../config';

const TableWrapper = styled.div`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(2){
    word-break: break-all;
    white-space: unset;
  }
`;

const InsiderCustomizationfeesList = ({refScrollerPage}) => {
  const {addOverlay} = useContext(OverlayContext);

  const [page, setPage] = useState(0);
  const [list, setList] = useState(null);
  const [listUsers, setListUsers] = useState([]);
  const [filterSearchUsers, setFilterSearchUsers] = useState([]);

  const [fetchError, setFetchError] = useState(false);

  const DEFAULT_FILTERS = {
    "search": "",
    "active": true,
    // "assigned": null,
    "userUuid": null
  };
  const [filters, setFilters] = useState(
    localStorage.getItem("ozwolConsoleFilterInsiderCustomizationfees"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))) ? 
      JSON.parse(localStorage.getItem("ozwolConsoleFilterInsiderCustomizationfees"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))))
    : 
      DEFAULT_FILTERS
    );
  const [filtersSearch, setFiltersSearch] = useState({
    "userUuid": ""
  });

  const changeFilters = useCallback((name, value) => {
    setPage(0);
    let tempFilters = {...filters};
    tempFilters[name] = value;
    setFilters(tempFilters);
  }, [filters]);

  const searchFilters = useCallback((name, value) => {
    let tempFiltersSearch = {...filtersSearch};
    tempFiltersSearch[name] = value;
    setFiltersSearch(tempFiltersSearch);


    if(value.length > 2 || value.length === 0){
      switch(name){
        case "userUuid":
          UsersService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response) => {
            setFilterSearchUsers(response.result);
          });
          break;
        default:
          break;
      }
    }

  }, [filtersSearch]);

  const getList = useCallback(() => {
    CustomizationfeesService.adminList({
      "userUuid": filters.userUuid
    }).then((response) => {
      localStorage.setItem("ozwolConsoleFilterInsiderCustomizationfees"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)), JSON.stringify(filters));
      setList(response);
    }).catch((error) => {
      setFetchError(formatError(error));
    });

  }, [filters]); //page, filters

  const deleteItem = useCallback((item) => {
    // setList(null);
    CustomizationfeesService.adminDelete(item.uuid).then((response) => {
      getList();
    }).catch((error) => {
      addOverlay({
        reference: "error",
        content: <ModalError>{formatError(error)}</ModalError>,
        timeout: OVERLAY_TIMEOUT_ERROR
      });
    });
  }, [getList, addOverlay]);

  useEffect(() => {
    getList();
  }, [getList, page, filters]); 

  

  useEffect(() => {
    UsersService.adminList().then((response) => {
      setFilterSearchUsers(response.result);
      setListUsers(response.result);
    });
  }, []);


  return (
    <OzContainer size="extra">
			<Meta title={"Customization fees - Insider"} />
			<PageHeader
				breadcrumbsIcon="euro_symbol"
        breadcrumbsText={["Customization fees"]}
        refScrollerPage={refScrollerPage}
        buttons={[
          {
            "icon": "add",
            "text": "Add",
            "onClick": () => addOverlay({
              reference: "form",
              content: <InsiderCustomizationfeesModalNew />
            })
          }
        ]}
      />

      <OzRow>
        <OzCol>
          <HealthyWrapper error={fetchError} loading={!list}>
            <OzCard
              headerLeft={
                <CardHeaderTitle 
                  title={"Customization fees"}
                />
              }
              headerSeparator={true}
            >
              <Filters
                onChange={(...args) => changeFilters(...args)}
                onSearch={(...args) => searchFilters(...args)}
                fields={
                  [
                    {
                      "label": "Owner",
                      "name": "userUuid",
                      "size": 6,
                      "type": "searchableselect",
                      "placeholder": null,
                      "value": filters.userUuid,
                      "options": [{
                        "name": <i>All</i>,
                        "value": null,
                      }].concat(filterSearchUsers.map((item) => ({
                        "name": <OzUserTag
                            name={item.givenName + " " + item.familyName}
                            company={item.company}
                            direction={"horizontal"}
                          />,
                        "value": item.uuid,
                      })))
                    },{
                      "size": 2,
                      "type": "clear",
                      "callback": () => {
                        setFilters(DEFAULT_FILTERS);
                        // localStorage.removeItem("ozwolConsoleFilterInsiderCustomizationfees"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)))
                      }
                    }
                  ]
                }
              />
              <hr/>

            
              {list && list.length > 0 ?
                <>
                  <TableWrapper>
                    <OzTable
                      columns={[
                        "Day",
                        "Description",
                        "Price",
                        "Quantity",
                        "Owner"
                      ]}
                      values={
                        list.map(item => ({
                          values: [
                            item.day,
                            item.description,
                            item.price,
                            item.quantity,
                            listUsers.filter(val => val.uuid === item.ownerUuid).length > 0 ?
                              listUsers.filter(val => val.uuid === item.ownerUuid).map(user =>
                                <OzUserTag
                                  key={user.uuid}
                                  name={user.givenName + " " + user.familyName}
                                  email={user.email}
                                />
                              )
                            : "-",
														<>
															<PromptedButton 
																buttonVariant="push-bittersweet" 
																buttonSize={"small"} 
																buttonText={<span className="material-symbols-outlined">delete</span>} 
																prompt="DELETE"
																buttonNoMinWidth={true}
																onConfirm={() => deleteItem(item)} 
															/> 
                            </>
                          ]
                        }))
                      }
                    />
                  </TableWrapper>
                </>
              : <NoResult />}           
            </OzCard>          
          </HealthyWrapper>    
        </OzCol>
      </OzRow>
    </OzContainer>
  )
}

export default InsiderCustomizationfeesList;
